export const selectFavorites = state => state.favorites.favorites;
